if (!customElements.get('card-product-media-slider')) {
  class CardProductMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.inView = false;
      this._io = null;
    }

    connectedCallback() {
      this._onCardProductVideoEnded = e => {
        const t = e.target;
        if (t.nodeName !== 'VIDEO') return;
        if (!t.classList.contains('card-product__slide-video')) return;
        t.currentTime = 0;
        t.play().catch(() => {});
      };
      this.addEventListener('ended', this._onCardProductVideoEnded, true);
      this.initSlider();
      this.setupIntersectionObserver();
    }

    pauseAllVideos() {
      this.querySelectorAll('.swiper video').forEach(video => {
        video.pause();
      });
    }

    syncActiveSlideVideo() {
      if (!this.inView) return;

      const sliderEl = this.querySelector('.swiper');
      if (!sliderEl) return;

      this.pauseAllVideos();

      const activeSlide = sliderEl.querySelector('.swiper-slide-active');
      const video = activeSlide?.querySelector('video');
      if (video) {
        video.play().catch(() => {});
      }
    }

    setupIntersectionObserver() {
      if (!('IntersectionObserver' in window)) {
        this.inView = true;
        this.syncActiveSlideVideo();
        return;
      }

      this._io = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            this.inView = entry.isIntersecting;
            if (entry.isIntersecting) {
              this.syncActiveSlideVideo();
            } else {
              this.pauseAllVideos();
            }
          }
        },
        { rootMargin: '80px 0px', threshold: 0.01 }
      );
      this._io.observe(this);
    }

    initSlider() {
      const sliderContainer = this.querySelector('.swiper');
      if (!sliderContainer) return;

      const pagination = this.querySelector('.swiper-pagination');
      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      const host = this;

      this.slider = new Swiper(sliderContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 3
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        on: {
          init: function () {
            if (pagination) {
              pagination.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
              });
            }
            if (nextButton) {
              nextButton.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
              });
            }
            if (prevButton) {
              prevButton.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
              });
            }
          },
          slideChangeTransitionEnd: function () {
            host.syncActiveSlideVideo();
          }
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('ended', this._onCardProductVideoEnded, true);
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }
  }

  customElements.define('card-product-media-slider', CardProductMediaSlider);
}
